import React from "react";
import CurrencyDisplay from "../../shared/currency-display";
import GenericItem from "./generic-item";
import MiscellaneousItem from "./miscellaneous-item";

function Miscellaneous(props) {
  const {
    budget,
    onChangeItemBuget,
    onChangeItemDays,
    showHideItems,
    visible,
    readOnly,
    filmId,
    saving,
    title,
    url,
    items,
    total,
    onAddFixedItem,
    onAddDailyItem,
    onChangeMiscellaneousItemBuget,
    onChangeMiscellaneousItemName,
    onChangeMiscellaneousItemDays
  } = props;

  const changeMiscellaneousItemBuget = (id, value) => {
    onChangeMiscellaneousItemBuget(id, value);
  };

  return (
    <div>
      <div className="columns subtitle is-4 mt-1">
        <div className="column">
          <h4
            className="subtitle is-4 pointer"
            onClick={() => showHideItems(!visible)}>
            <button className="button is-text is-small">
              {!visible && <i className="material-icons">add</i>}
              {visible && <i className="material-icons">remove</i>}
            </button>
            {title}
          </h4>
        </div>
        <div className="column budget-header-number">
          <CurrencyDisplay
            value={total}
          />
        </div>
      </div>
      {visible && (
        <>
          <table className="table budget-table is-fullwidth">
            <thead>
              <tr>
                <th>Name</th>
                <th>Days</th>
                <th className="budget-daily-rate-column">Budget</th>
                <th className="has-text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {(items || []).map((item, i) => {
                return (
                  <MiscellaneousItem
                    key={i}
                    item={item}
                    onChangeItemBuget={changeMiscellaneousItemBuget}
                    onChangeItemName={onChangeMiscellaneousItemName}
                    onChangeItemDays={onChangeMiscellaneousItemDays}
                    maxDays={budget.days}
                    totalScenes={budget.totalScenes}
                    hasShootingDays={budget.hasShootingDays}
                    readOnly={readOnly}
                    filmId={filmId}
                    saving={saving}
                  />
                );
              })}
              <tr>
                <td colSpan={3}></td>
                <td className="has-text-right">
                  <CurrencyDisplay
                    value={total}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <button
            className="button is-small"
            onClick={onAddFixedItem}>
            <i className="material-icons">add</i> Add Fixed
          </button>

          <button
            className="button is-small ml-1"
            onClick={onAddDailyItem}>
            <i className="material-icons">add</i> Add Daily
          </button>
        </>
      )}
    </div>
  );
}

export default Miscellaneous;
